import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { closeAlert, preventCopy } from "./common"
import { isBrowser, isElectron, isIOS } from 'react-device-detect';

const startApp = async (props) => {
    if ("serviceWorker" in navigator) {
        if ((isBrowser || isElectron) && 1 === 0) {
            // const regURL = "./fcm/firebase-messaging-sw.js";
            const regURL = '';
            navigator.serviceWorker.register(regURL, {
                updateViaCache: 'none'
            }).then(async (registration) => {
            }).catch((e) => {
                let _emsg = "Service worker registration failed";
                if (navigator.notification) {
                    // navigator.notification.alert(
                    //     _emsg, 
                    //     closeAlert, 
                    //     'Error', 
                    //     'Close'
                    // );
                } else {
                }

                
            }).finally(() => {
                ReactDOM.render(<App device={props} />, document.getElementById('root'));
            });
        } else {
            ReactDOM.render(<App device={props}/>, document.getElementById('root'));
        }
    } else {
        ReactDOM.render(<App device={props}/>, document.getElementById('root'));
    }
}

if (window.cordova) {
    document.addEventListener('deviceready', startApp(true), false);
    function onDeviceReady() {
        if (isIOS) {
            window.cordova.plugins.disableCopyPaste.start(function(){
            }, function(sError) {
            });
        }

        window.open = window.cordova.InAppBrowser.open;
    }
    try {
        navigator.splashscreen.hide();
    } catch (e) {
    }
    
} else {
    preventCopy();
    startApp(false)
};

serviceWorker.unregister();